module.exports = __webpack_public_path__ + "static/media/loader-bg.9ed84ef7.png";